<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
            <v-slide-x-reverse-transition>
                <v-alert type="error" class="alert_all_page" v-if="alert_error === true">{{ alert_message_error
                    }}</v-alert>
                <v-alert type="success" class="alert_all_page" v-if="alert_success === true">{{ alert_message_success
                    }}</v-alert>
            </v-slide-x-reverse-transition>
            <v-row>
                <v-col xs="12" sm="12" md="9" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">สร้างใบแจ้งหนี้/ใบกำกับภาษี</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="3" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()"
                            large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>

            </v-row>
            <div class="mt-1">
                <v-card elevation="3" class="pa-5 " style="border-radius: 15px;">
                    <section class="pa-3">
                        <v-form ref="setting" @submit.prevent="saveData()">
                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/avatar_white.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ข้อมูลสมาชิก</div>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row class="pl-10">
                                <v-col xs="6" sm="6" md="6" lg="4" xl="4" cols="6" class="pa-3 py-0 ">
                                    <div class="text_title mt-2">เลขที่ใบเสร็จ <span class="red--text">*</span></div>
                                    <div class="mt-2">
                                        <v-autocomplete color="#D6BFAF" class="input-radius" @change="getinvoiceDetail"
                                            v-model="invoice_number" :items="invoice_item" item-text="invoice_code"
                                            item-value="invoice_id" :rules="[v => !!v || 'กรุณาเลือกเลขที่ใบเสร็จ']"
                                            hide-details="auto" label="กรุณากรอกเลขที่ใบเสร็จ" required outlined dense
                                            deletable-chips></v-autocomplete>
                                    </div>
                                </v-col>

                                <v-col xs="6" sm="6" md="6" lg="3" xl="3" cols="6">
                                    <div class="text_title mt-8 ">วันที่เอกสาร : {{ customer_data.doc_date_format !=
                                        null
                                        ?
                                        customer_data.doc_date_format : '-' }} </div>
                                </v-col>
                                <!-- <v-col cols="auto"></v-col> -->

                                <v-col cols="6" class="pa-3 py-0 ">
                                    <v-form-group>
                                        <div class="text_title mt-2 mb-0">เคยออกใบกำกับภาษีหรือไม่ ? <span
                                                class="red--text">*</span></div>
                                        <v-radio-group hide-details="auto" v-model="typeInvoice" row>
                                            <v-radio label="เคยออกใบกำกับภาษี" color="#D6BFAF" :value="1"></v-radio>
                                            <v-radio label="ไม่เคยออกใบกำกับภาษี" color="#D6BFAF" :value="0"></v-radio>
                                        </v-radio-group>
                                    </v-form-group>
                                </v-col>
                                <v-col cols="6" class="pa-3 py-0 ">
                                    <div class="text_title mt-2">เลขที่สาขา</div>
                                    <div class="mt-2">
                                        <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto"
                                            v-model="customer_data.branch_number" placeholder="กรุณากรอกชื่อผู้ซื้อ"
                                            outlined dense required maxlength="100"></v-text-field>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="6" class="pa-3  py-2"
                                    v-if="typeInvoice === 0">
                                    <div class="text_title mt-2">ชื่อผู้ซื้อ <span class="red--text">*</span></div>
                                    <div class="mt-2">
                                        <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto"
                                            v-model="customer_data.buyer_name" :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                                            placeholder="กรุณากรอกชื่อผู้ซื้อ" outlined dense required
                                            maxlength="100"></v-text-field>
                                    </div>
                                </v-col>
                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="6" class="pa-3 py-2" v-else>
                                    <div class="text_title mt-2">ชื่อผู้ซื้อ <span class="red--text">*</span></div>
                                    <div class="mt-2">
                                        <v-autocomplete color="#D6BFAF" class="input-radius" @change="getMemberDetail"
                                            v-model="buyer_name" :items="formattedCustomerInv" item-text="buyer_name"
                                            item-value="buyer_name" :rules="[v => !!v || 'กรุณาเลือกผู้ซื้อ']"
                                            hide-details="auto" label="กรุณาเลือกผู้ซื้อ" required outlined dense
                                            deletable-chips></v-autocomplete>
                                    </div>
                                </v-col>

                                <v-col xs="12" sm="12" md="6" lg="6" xl="6" cols="6" class="pa-3 py-2">
                                    <div class="text_title mt-2">เลขที่เสียภาษี </div>
                                    <div class="mt-2">
                                        <v-text-field color="#D6BFAF" class="input-radius" hide-details="auto"
                                            v-model="customer_data.tax_number" placeholder="กรุณากรอกเลขที่เสียภาษี"
                                            outlined dense
                                            @keypress="isTelephone($event, customer_data.tax_number)"></v-text-field>
                                    </div>
                                </v-col>

                                <v-col cols="12 mt-0 pa-3 pt-0" sm="12" md="6" lg="6" xl="6">
                                    <div class="text_title">ที่อยู่</div>
                                    <div class="mt-2">
                                        <v-textarea class="input-radius" placeholder="กรุณากรอกที่อยู่"
                                            v-model="customer_data.address" color="#D6BFAF" auto-grow outlined rows="3"
                                            row-height="25" shaped maxLength="255"></v-textarea>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                    <div class="d-flex">
                                        <div class="title_form_main">
                                            <div class="logo_timeline">
                                                <img src="@/assets/arin_assets/box.png">
                                            </div>
                                        </div>
                                        <div class="header-content py-1 pl-5 pr-5 text-center">
                                            <div class="content-font">ข้อมูลสินค้า</div>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-center" width="100">
                                                        <div class="font-16"> ลำดับ </div>
                                                        <div class="font-16"> No. </div>
                                                    </th>
                                                    <th class="text-left">
                                                        <div class="font-16"> รายการสินค้า </div>
                                                        <div class="font-16"> Description </div>
                                                    </th>
                                                    <th class="text-center">
                                                        <div class="font-16"> จำนวน </div>
                                                        <div class="font-16"> Quantity </div>
                                                    </th>
                                                    <th class="text-right">
                                                        <div class="font-16 mr-5"> ราคาต่อหน่วย </div>
                                                        <div class="font-16 mr-7"> Unit Price </div>
                                                    </th>
                                                    <th class="text-right">
                                                        <div class="font-16 mr-7"> ส่วนลด </div>
                                                        <div class="font-16 mr-5"> Discount </div>
                                                    </th>
                                                    <th class="text-right">
                                                        <div class="font-16 mr-10"> จำนวนเงิน (บาท) </div>
                                                        <div class="font-16 mr-10"> Amount (Baht) </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, i) in data_list" :key="i">
                                                    <td class="text-center font-16">
                                                        <div class="font-16">{{ i + 1 }}</div>
                                                    </td>
                                                    <td>
                                                        <div class="font-16">{{ item.product_name }}</div>
                                                    </td>
                                                    <td class="text-center font-16">
                                                        <div class="font-16">{{ parseInt(item.qty) }}
                                                            {{ item.unit_name == '-' ? '' : item.unit_name }}</div>
                                                    </td>
                                                    <td class="text-right font-16">
                                                        <div class="mr-10 font-16" v-if="item.is_promotion == 1">
                                                            -{{ formatPrice(item.price) }}
                                                        </div>
                                                        <div class="mr-10 font-16" v-else>
                                                            {{ formatPrice(item.price) }}
                                                        </div>
                                                    </td>
                                                    <td class="text-right font-16">
                                                        <div class="mr-7 font-16">
                                                            {{ formatPrice(item.discount) }}
                                                        </div>
                                                    </td>
                                                    <td class="text-right ">
                                                        <div class="mr-10 font-16" v-if="item.is_promotion == 1">-{{
                                                            formatPrice(parseFloat(item.total)) }}</div>
                                                        <div class="mr-10 font-16" v-else>{{
                                                            formatPrice(parseFloat(item.total)) }}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td colspan="4" class="text-right font-16">
                                                        <div class="font-16">รวมเงิน (Sub Total)</div>
                                                    </td>
                                                    <td class="text-right">
                                                        <div class="mr-10 font-16">
                                                            {{ formatPrice(parseFloat(customer_data.total)) }}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td colspan="4" class="text-right font-16">
                                                        <div class="font-16">ส่วนลดท้ายบิล (Discount)</div>
                                                    </td>
                                                    <td class="text-right">
                                                        <div class="mr-10 font-16">
                                                            {{ formatPrice(customer_data.discount) }}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td colspan="4" class="text-right font-16">
                                                        <div class="font-16">มูลค่าสินค้า (Total)</div>
                                                    </td>
                                                    <td class="text-right">
                                                        <div class="mr-10 font-16">{{ formatPrice(customer_data.cost) }}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td colspan="4" class="text-right font-16">
                                                        <div class="font-16">ภาษีมูลค่าเพิ่ม (VAT) 7%</div>
                                                    </td>
                                                    <td class="text-right">
                                                        <div class="mr-10 font-16">{{ formatPrice(customer_data.vat) }}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-if="seller.pay_type.find(o => o === 3)">
                                                    <td></td>
                                                    <td colspan="4" class="text-right font-16">
                                                        <div class="font-16">เครดิตชาร์จ (credit charge)
                                                            {{ parseFloat(seller.credit_charge) }}%</div>
                                                    </td>
                                                    <td class="text-right">
                                                        <div class="mr-10 font-16">
                                                            {{ formatPrice(parseFloat(customer_data.credit_uncharge) *
                                                                parseFloat(seller.credit_charge_status == 1 ?
                                                                    parseFloat(seller.credit_charge) / 100 : 0)) }}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td colspan="4" class="text-right font-16">
                                                        <div class="font-16">คะแนนส่วนลด (Discount Points)</div>
                                                    </td>
                                                    <td class="text-right">
                                                        <div class="mr-10 font-16">
                                                            {{ formatPrice(customer_data.use_point) }}</div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td></td>
                                                    <td class="font-16">
                                                        <div class="font-16" v-if="!seller.pay_type.find(o => o === 3)">
                                                            {{ THBText(parseFloat(customer_data.net_total) -
                                                                parseFloat(customer_data.use_point)) }}</div>
                                                        <div class="font-16" v-else>
                                                            {{ THBText((parseFloat(customer_data.net_total) +
                                                                parseFloat(customer_data.net_total) *
                                                                parseFloat(seller.credit_charge_status == 1 ?
                                                                    parseFloat(seller.credit_charge) / 100 :
                                                                    0)) - (parseFloat(customer_data.use_point))) }}</div>
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td class="text-right font-16">
                                                        <div class="font-16">ยอดเงินสุทธิ (NET Total)</div>
                                                    </td>
                                                    <td class="text-right ">
                                                        <div v-if="!seller.pay_type.find(o => o === 3)"
                                                            class="mr-10 font-16">
                                                            {{ formatPrice(parseFloat(customer_data.net_total) -
                                                                parseFloat(customer_data.use_point)) }}</div>
                                                        <div v-else class="mr-10 font-16">
                                                            {{ formatPrice(parseFloat(customer_data.net_total)
                                                                - (parseFloat(customer_data.use_point))) }}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>

                            <div class="text-right mt-6 mb-3">
                                <v-btn type="submit" height="45" width="150"
                                    class="white--text grad-success-arin-bg mobile_btn"
                                    style="font-size: 18px; border-radius: 10px;">บันทึก</v-btn>
                            </div>
                        </v-form>
                    </section>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice, taxNumber } from "@/js/handler";
import THBText from 'thai-baht-text'
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_invoices_tax_add",
    data() {
        return {
            loading_page: false,
            alert_error: false,
            alert_message_error: null,
            alert_success: false,
            alert_message_success: null,
            dialog_cancel_order: false,
            invoice_item: [],
            invoice_number: [],
            invoice_date: null,
            invoice_name: null,
            invoice_address: null,
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            typeInvoice: 1,
            data_list: [],
            customerInv: [],
            buyer_name: null,
            sub_menu: [
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'การขาย',
                    disabled: false,
                },
                {
                    text: 'ใบแจ้งหนี้/ใบกำกับภาษี',
                    disabled: false,
                },
                {
                    text: 'สร้างใบแจ้งหนี้/ใบกำกับภาษี',
                    disabled: false,
                },
            ],
            customer_data: {
                doc_date_format: null,
                buyer_name: null,
                address: null,
                branch_number: null,
                cost: "0.00",
                discount: "0.00",
                discount_product: '0.00',
                total: "0.00",
                vat: "0.00",
                net_total: "0.00",
                use_point: '0.00',
                net_total_text: "-",
                pay_type: []
            },
            seller: {
                pay_type: [],
                credit_charge_status: null,
                credit_charge: null
            }
        }
    },
    methods: {
        THBText(text) {
            return THBText(text)
        },
        formatPrice(number) {
            return formatPrice(number)
        },
        isTelephone(evt, number) {
            return taxNumber(evt, number)
        },
        async getInvoiceCodeSelectbox() {
            this.loading_page = true
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            await HTTP_ARIN.get('/invoice/list/to/select/box', config).then((res) => {
                if (res.data.successful === true) {
                    this.loading_page = false
                    this.invoice_item = res.data.data
                    if (this.$route.params.id) {
                        this.invoice_number = parseFloat(this.$route.params.id)
                        this.getinvoiceDetail(this.$route.params.id)
                    }
                }
            })
        },
        async getCustomerInvoice() {
            this.loading_page = true
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            await HTTP_ARIN.get('/tax/invoice/customer-have-tax-invoice', config).then((res) => {
                if (res.data.successful === true) {
                    this.customerInv = res.data.data;
                    this.loading_page = false
                }
            })
        },
        getMemberDetail() {
            const selectedCustomer = this.customerInv.find(customer => customer.buyer_name === this.buyer_name);

            if (selectedCustomer) {
                // ตรวจสอบว่า member_id และ member มีค่าหรือไม่
                this.customer_data.tax_number = selectedCustomer.tax_number || ''; // กำหนด tax number
                if (selectedCustomer.member_id === null) {
                    this.customer_data.buyer_name = selectedCustomer.buyer_name;
                    this.customer_data.address = selectedCustomer.address;
                } else if (selectedCustomer.member && selectedCustomer.member.buyer_name) {
                    this.customer_data.buyer_name = selectedCustomer.member.buyer_name;
                    this.customer_data.address = selectedCustomer.member_address;
                } else {
                    this.customer_data.buyer_name = ''; // กำหนดค่าเริ่มต้นหากไม่พบ buyer_name
                    this.customer_data.address = '';
                }
            } else {
                // กำหนดค่าเริ่มต้นหากไม่พบข้อมูลลูกค้า
                this.customer_data.tax_number = '';
                this.customer_data.buyer_name = '';
                this.customer_data.address = '';
            }
        },
        async getStoreDetail() {
            this.loading_page = true
            this.seller.credit_charge_status = this.customer_data.credit_charge_status;
            this.seller.credit_charge = this.customer_data.credit_charge;
            this.seller.pay_type = this.customer_data.pay_type
            this.loading_page = false
        },
        getinvoiceDetail(id) {
            this.loading_page = true
            this.customer_data = this.invoice_item.find(o => o.invoice_id === parseFloat(id))
            if (this.customer_data != null) {
                this.customer_data.total = 0;
                this.data_list = this.customer_data.product_list.map(item => {
                    if (item.is_promotion == 0) {
                        this.customer_data.total += parseFloat(item.total)
                    } else if (item.is_promotion == 1) {
                        // ลบ total ของสินค้าที่เป็นโปรโมชั่น
                        this.customer_data.total -= parseFloat(item.total)
                    }
                    return { ...item }
                })
                let sum = 0
                this.data_list.map(item => {
                    sum = sum + parseFloat(item.discount)
                    this.customer_data.discount_product = sum
                })
                this.customer_data.use_point = this.customer_data.use_point ? this.customer_data.use_point : '0.00'
                this.seller.pay_type = this.customer_data.pay_type
            } else {
                this.customer_data = {
                    doc_date_format: null,
                    buyer_name: null,
                    address: null,
                    branch_number: null,
                    cost: "0.00",
                    discount: "0.00",
                    discount_product: '0.00',
                    total: "0.00",
                    vat: "0.00",
                    net_total: "0.00",
                    use_point: '0.00',
                    net_total_text: "-",
                    pay_type: []
                },
                    this.seller = {
                        pay_type: [],
                        credit_charge_status: null,
                        credit_charge: null
                    }
                this.data_list = []
            }
            this.getStoreDetail()
            this.loading_page = false
        },
        async saveData() {
            if (this.$refs.setting.validate()) {
                if (this.buyer_name) {
                    this.customer_data.buyer_name = this.buyer_name;
                }

                let data = {
                    invoice_id: this.customer_data.invoice_id,
                    buyer_name: this.customer_data.buyer_name,
                    branch_number: this.customer_data.branch_number,
                    tax_number: this.customer_data.tax_number,
                    address: this.customer_data.address,
                    doc_date: this.customer_data.doc_date
                }
                this.loading_page = true
                let config = {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                    }
                }
                await HTTP_ARIN.post('/tax/invoice/create', data, config).then((res) => {
                    if (res.data.successful === true) {
                        this.loading_page = false
                        this.alert_success = true
                        this.alert_message_success = 'สร้างใบแจ้งหนี้/ใบกำกับภาษี สำเร็จ'
                        setTimeout(() => this.alert_success = false, 5000)
                        this.$router.push('/arin/pos/posinvoicestax')
                    }
                })
            }
        },
    },
    computed: {
        formattedCustomerInv() {
            return this.customerInv.map(customer => {
                return {
                    ...customer,
                    buyer_name: customer.member_id === null || !customer.member ? customer.buyer_name : customer.member.buyer_name,
                };
            });
        }
    },
    mounted() {
        this.getInvoiceCodeSelectbox()
        this.getCustomerInvoice()

    }
}
</script>

<style scoped>
.btn_add_data {
    font-size: 16px;
    color: #FFF;
    background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
    border-radius: 10px;
    /* width: 100%; */
}
</style>